import { useEffect, useState } from 'react'
import { Button } from '../common/Button'
import { motion } from 'framer-motion'
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi'
import { settingsService } from '../../services/settingsService'

export const Hero = ({ onGetStarted }: { onGetStarted: () => void }) => {
  const [trialDays, setTrialDays] = useState<number | null>(null)

  useEffect(() => {
    settingsService.getTrialDays().then(setTrialDays)
  }, [])

  return (
    <section id="hero" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-50 via-white to-primary-50">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center lg:text-left"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Gerencie Projetos e Tarefas com{' '}
                <span className="text-primary-600">Eficiência</span>
              </h1>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0"
            >
              Plataforma completa de gestão de projetos com dashboard inteligente, 
              Kanban, OKRs e muito mais. Organize sua equipe e alcance resultados extraordinários.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8"
            >
              <Button
                onClick={onGetStarted}
                variant="primary"
                size="lg"
                className="group"
              >
                Começar Grátis
                <FiArrowRight className="ml-2 inline group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => {
                  const element = document.getElementById('features')
                  element?.scrollIntoView({ behavior: 'smooth' })
                }}
                variant="outline"
                size="lg"
              >
                Ver Funcionalidades
              </Button>
            </motion.div>

            {/* Social Proof */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm text-gray-600"
            >
              <div className="flex items-center gap-2">
                <FiCheckCircle className="text-green-500" />
                <span>{trialDays !== null ? `${trialDays} dias de testes` : 'Período de testes grátis'}</span>
              </div>
              <div className="flex items-center gap-2">
                <FiCheckCircle className="text-green-500" />
                <span>Cancela a qualquer momento</span>
              </div>
              <div className="flex items-center gap-2">
                <FiCheckCircle className="text-green-500" />
                <span>Suporte fácil e rápido</span>
              </div>
            </motion.div>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="relative"
          >
            <div className="relative bg-white rounded-2xl shadow-2xl p-4 border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-br from-primary-50 via-white to-primary-100 rounded-lg p-8 min-h-[400px] flex items-center justify-center">
                <div className="text-center text-gray-400">
                  <div className="text-6xl mb-4">📊</div>
                  <p className="text-lg font-medium">Dashboard Preview</p>
                  <p className="text-sm mt-2">Screenshot da aplicação será adicionado aqui</p>
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-4 left-4 w-full h-full bg-primary-200 rounded-2xl opacity-20"></div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

